import { AnimatePresence, motion } from 'framer-motion';
import { useCallback, useRef, useState } from 'react';
const COPY_TIMEOUT = 1500;

export function CopyButton(props: { value: string }) {
  const { value } = props;

  const copyToClipBoard = useCallback((copiedValue: string) => {
    // In secure contexts, clipboard is defined always
    navigator.clipboard.writeText(copiedValue);
  }, []);
  const [copied, setCopied] = useState(false);
  const timeoutIdRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleCopy = useCallback(() => {
    setCopied(true);

    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }
    timeoutIdRef.current = setTimeout(() => {
      setCopied(false);
    }, COPY_TIMEOUT);

    copyToClipBoard(value.toString());
  }, [copyToClipBoard, value]);

  return (
    <button onClick={handleCopy} className="flex flex-1 items-center justify-end gap-2 text-right font-semibold">
      {value}
      <AnimatePresence>
        {copied && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="-4 -4 32 32"
              fill="none"
              stroke="#2563eb"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ verticalAlign: 'middle' }}
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </motion.div>
        )}
        {!copied && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                opacity="0.4"
                d="M8 7H7.4C6.6268 7 6 7.6268 6 8.4V18.6C6 19.3732 6.6268 20 7.4 20H13.6C14.3732 20 15 19.3732 15 18.6V17.1111"
                stroke="#005CE5"
                strokeWidth="1.8"
                strokeLinecap="round"
              />
              <path
                d="M18 15.6V5.4C18 4.6268 17.3732 4 16.6 4H10.4C9.6268 4 9 4.6268 9 5.4V15.6C9 16.3732 9.6268 17 10.4 17H16.6C17.3732 17 18 16.3732 18 15.6Z"
                stroke="#005CE5"
                strokeWidth="1.8"
                strokeLinecap="round"
              />
            </svg>
          </motion.div>
        )}
      </AnimatePresence>
    </button>
  );
}
